import React from 'react'
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@material-ui/core/IconButton";
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import CallIcon from '@material-ui/icons/Call';

const useStyles = makeStyles({
    footer: {
        backgroundColor: '#fada5e',
        height: '100%',
        marginTop: '40px',
        width: '100%'
    },
    heading: {
        color: 'Black',
        marginTop: '10px'
    },
    icons: {
        marginTop: '0px',
        color: 'Black',
        '&:hover': {
            backgroundColor: 'crimson'
        }
    }
})

function Footer() {
    const classes = useStyles();

    return (
        <div className={classes.footer}>
            <Container>
                <Grid container alignItems='center' justify='center' direction='column'>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        
                        <p className={classes.heading}>Copyright © 2022 Noon Yacht</p>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>

                    <IconButton className={classes.icons}
                    target="_blank"
                    href='https://www.facebook.com/habibiyachtsevents/'
                    >
                        <FacebookIcon />
                    </IconButton>
                    
                    <IconButton className={classes.icons}
                    target="_blank"
                    href='https://www.instagram.com/noon_yachts?r=nametag'
                    >
                        <InstagramIcon />
                    </IconButton>
                    
                    <IconButton
                        target="_blank"
                        href='https://wa.me/+971567033102'
                        className={classes.icons}
                    >
                        <WhatsAppIcon />
                    </IconButton>

                    <IconButton
                    className={classes.icons}
                    href="tel:+971567033102" >
                                <CallIcon />
                    </IconButton>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default Footer;